import { Type83fEnum } from '@crm/api/types.gen'
import { useLocales } from '@shared/locales'
import { Form, FormInstance, Input, InputNumber, Select } from 'antd'
import { TFunction } from 'i18next'

type Props = {
  form: FormInstance
}

const getBooleanOptions = (t: TFunction) => [
  { label: t('nomenclature.true'), value: true },
  { label: t('nomenclature.false'), value: false }
]

const getDateOptions = (t: TFunction) => [
  { label: t('nomenclature.yesterday'), value: 'yesterday' },
  { label: t('nomenclature.today'), value: 'today' },
  { label: t('nomenclature.tomorrow'), value: 'tomorrow' },
  { label: t('nomenclature.week_after'), value: 'week_after' },
  { label: t('nomenclature.two_weeks_after'), value: 'two_weeks_after' },
  { label: t('nomenclature.month_after'), value: 'month_after' },
  { label: t('nomenclature.three_months_after'), value: 'three_months_after' }
]

const getSelectOptions = (
  options: { value: string; label: string }[] | undefined
) => {
  const filteredOptions = options?.filter(
    (option) => option?.value || option?.label
  )

  return (
    filteredOptions?.map((option: { value: string; label: string }) => ({
      label: option?.value || option?.label,
      value: option?.label
    })) ?? []
  )
}

export const DefaultValueFormItem = ({ form }: Props) => {
  const { t } = useLocales()

  const type = Form.useWatch('type', form)
  const options = Form.useWatch('options', form)

  const fieldMap = {
    [Type83fEnum.TEXT]: <Input placeholder={t('nomenclature.default_value')} />,
    [Type83fEnum.NUMBER]: (
      <InputNumber
        className="w-full"
        placeholder={t('nomenclature.default_value')}
      />
    ),
    [Type83fEnum.BOOLEAN]: (
      <Select
        placeholder={t('nomenclature.default_value')}
        options={getBooleanOptions(t)}
        allowClear
      />
    ),
    [Type83fEnum.DATE]: (
      <Select
        placeholder={t('nomenclature.default_value')}
        options={getDateOptions(t)}
        allowClear
      />
    ),
    [Type83fEnum.SELECT]: (
      <Select
        placeholder={t('nomenclature.default_value')}
        options={getSelectOptions(options)}
        allowClear
      />
    ),
    [Type83fEnum.MULTISELECT]: (
      <Select
        mode="multiple"
        placeholder={t('nomenclature.default_value')}
        options={getSelectOptions(options)}
        allowClear
      />
    )
  }

  const renderField = () => type && fieldMap[type as keyof typeof fieldMap]

  return (
    <Form.Item name="default_value" label={t('nomenclature.default_value')}>
      {renderField()}
    </Form.Item>
  )
}
